<template>
  <el-dialog custom-class="data-collection-select-container dialog-size-middle"
             :title="'収集データの選択'"
             top="0"
             :modal="false"
             :append-to-body="true"
             :visible.sync="visible"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <div class="data-collection-select-container-inner">
      <el-menu class="data-collection-select-navi-container" mode="vertical"
               :default-active="selectedDataCollection ? getMenuIndex(selectedDataCollection) : ''">
        <div v-for="data in getUniqueDataCollection()" :key="data.dataCollectionId">
          <template v-if="dataCollectionFilterById(data.dataCollectionId).length === 0">
            <el-menu-item :index="getMenuIndex(data)" @click="onClickMenuItem(data)">
              <span slot="title">{{ data.dataCollectionName }}</span>
            </el-menu-item>
          </template>

          <template v-else>
            <el-submenu :index="data.dataCollectionId">
              <template slot="title">
                <span slot="title">{{ data.dataCollectionName }}</span>
              </template>
              <template>
                <el-menu-item :index="getMenuIndex(category)"
                              v-for="category in dataCollectionFilterById(data.dataCollectionId)"
                              @click="onClickMenuItem(category)">
                  <span slot="title">{{ category.categoryName }}</span>
                </el-menu-item>
              </template>
            </el-submenu>
          </template>
        </div>
      </el-menu>
      <div class="data-collection-select-main-container">
        <h2>{{selectedDataCollection ? selectedDataCollection.categoryName ? selectedDataCollection.categoryName :
          selectedDataCollection.dataCollectionName : ''}}</h2>
        <p v-html="selectedDataCollection ? $options.filters.html_format(selectedDataCollection.description) : ''"></p>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible=false">キャンセル</el-button>
      <el-button type="primary" @click="onClickSelect">OK</el-button>
    </span>
  </el-dialog>

</template>

<script lang="js">
import CommonUtil from '../../../utils/common'
import { DATA_COLLECTION_DEFINES, DataCollectionSelect } from '../../../defines/data-collection'

export default {
  name: 'DataCollectionSelectDialogCmp',
  props: {
    selectedDataCollectionForInit: DataCollectionSelect
  },
  data () {
    return {
      selectedDataCollection: this.selectedDataCollectionForInit,
      visible: true
    }
  },
  methods: {
    dataCollectionFilterById (dataCollectionId) {
      return DATA_COLLECTION_DEFINES.filter(data => data.dataCollectionId === dataCollectionId && dataCollectionId &&
          CommonUtil.isNotEmpty(data.categoryId))
    },
    getUniqueDataCollection () {
      let values = []

      let result = DATA_COLLECTION_DEFINES.filter(data => {
        const value = data.dataCollectionId
        if (values.indexOf(value) === -1) {
          values.push(value)
          return data
        }
      })

      return result
    },
    getMenuIndex (category) {
      let index = category.dataCollectionId
      if (CommonUtil.isNotEmpty(category.categoryId)) {
        index += '__' + category.categoryId
      }
      return index
    },
    onClickMenuItem (category) {
      this.selectedDataCollection = category
      this.$forceUpdate()
    },
    onClickSelect () {
      this.$emit('select', this.selectedDataCollection)
      this.visible = false
    }
  }
}

</script>

<style type="scss" scoped>
  .data-collection-select-container-inner {
    display: flex;
    flex-direction: row;
    height: 470px;
  }

  .data-collection-select-container-inner > .data-collection-select-navi-container {
    flex-shrink: 0;
    width: 330px;
    overflow-y: scroll;
  }

  .data-collection-select-container-inner > .data-collection-select-main-container {
    flex-shrink: 0;
    flex-grow: 1;
    padding-left: 24px;
    max-width: 630px;
    overflow-y: scroll;
  }

  .data-collection-select-container-inner > .data-collection-select-main-container > h2 {
    margin: 0;
  }

  .data-collection-select-container-inner > .data-collection-select-main-container > p {
    margin-top: 0;
    word-wrap: break-word;
  }

  .data-collection-select-container-inner .data-collection-select-subset-select {
    cursor: pointer;
    margin-top: 0.5rem;
  }

  .title-info {
    font-size: 0.88rem;
  }

  .file-upload-content {
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/data-collect/dialogs/data-collect-select.vue